// export const Oss = 'http://112.124.43.214:9110/resource/c?r=';
// const oss2 = 'https://wkapp-course.oss-cn-hangzhou.aliyuncs.com/s10/n1/i10_audio1.mp3'
export const OssAudio = "https://wukong.wukong9527.cn";
export const OssImg = "https://wukong2.wukong9527.cn";
export const OssOther = "https://wkapp-other.oss-cn-hangzhou.aliyuncs.com";

// 阿里云 OSS 图片处理参数：转 WebP、质量 85（Detail 等页用，兼顾清晰度与体积）
const OSS_IMAGE_WEBP = 'x-oss-process=image/format,webp/quality,75';
// GIF 不转 webp，不加处理参数避免 400
const OSS_IMAGE_GIF = null;

/**
 * 为阿里云 OSS 图片 URL 拼接图片处理参数（WebP + 质量 85）
 * 规则：若 URL 已有 ? 则用 & 拼接，否则用 ? 拼接；非 OSS 域名不处理；GIF 不追加参数
 * @param {string} url - 完整图片 URL（如 OssImg + path 或 OssOther + path）
 * @returns {string} 带 OSS 处理参数的 URL，或原 URL（非 OSS 时）
 */
export const ossImageUrl = (url) => {
    if (!url || typeof url !== 'string') return url;
    const isOss = url.includes('oss-cn-') || url.includes('wukong9527');
    if (!isOss) return url;
    const process = url.toLowerCase().includes('.gif') ? OSS_IMAGE_GIF : OSS_IMAGE_WEBP;
    if (!process) return url;
    const sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + process;
};

// OSS 图片压缩参数 - 统一走 WebP 200KB 方案，减少内存占用
// width 保留兼容旧调用，实际使用 format,webp/quality,85
export const ossImageCompress = (url, width = 400) => {
    if (!url) return url;
    return ossImageUrl(url);
};
export const Android =
  "https://img2.baidu.com/it/u=299628358,1031369574&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1422";
export const agent = [
  "888",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
];

// VIP 白名单：命中后跳过 Menu/Detail 的会员与每日新关卡限制
// 支持 user_id 和 mobile 两种维度，按需填写
export const VIP_BYPASS_USER_IDS = [
  // "123456",
];

export const VIP_BYPASS_MOBILES = [
  "17835398086",
  "18235949416"
];

/** 统一白名单判断：兼容传入 user 或 user.data */
export const isVipBypassUser = (userLike) => {
  const user = userLike?.data || userLike || {};
  const userId = String(user?.user_id ?? "").trim();
  const mobile = String(user?.mobile ?? "").trim();
  if (!userId && !mobile) return false;
  return VIP_BYPASS_USER_IDS.includes(userId) || VIP_BYPASS_MOBILES.includes(mobile);
};

/** 全关卡访问：以后端用户字段为准，旧白名单作为兼容兜底 */
export const canAccessAllLevels = (userLike) => {
  const user = userLike?.data || userLike || {};
  return user?.access_all_levels === true || user?.access_all_levels === 1 || isVipBypassUser(user);
};
